const VENTAS = 'VENT'
const COTIZACION = 'COTI'
const ORDENCOMPRA = 'ORDE'
const GUIAVENTA = 'GUIAVENT'

const __dictionary = {
  [VENTAS]: {
    id: VENTAS,
    nombre: 'VENTAS'
  },
  [COTIZACION]: {
    id: COTIZACION,
    nombre: 'COTIZACION'
  },
  [ORDENCOMPRA]: {
    id: ORDENCOMPRA,
    nombre: 'ORDEN COMPRA'
  },
  [GUIAVENTA]: {
    id: GUIAVENTA,
    nombre: 'GUIA VENTA'
  }
}

const __array = [
  __dictionary[VENTAS],
  __dictionary[COTIZACION],
  __dictionary[ORDENCOMPRA],
  __dictionary[GUIAVENTA]
]

const __vaues = [VENTAS, COTIZACION, ORDENCOMPRA, GUIAVENTA]

export default Object.freeze({
  VENTAS,
  COTIZACION,
  ORDENCOMPRA,
  GUIAVENTA,
  __dictionary,
  __array,
  __vaues
})
